<script setup>
/**
 * FormControlModulestructureBrowser
 * Dynamic checkbox wrapper targeting structure layout configuration states.
 * Evaluates field type sets to present secondary contextual 'Make editable'
 * toggles, handling multi-state flag updates cleanly.
 */
import {computed} from 'vue'
import FormControlTypeCheckbox from '@/common/form-control-type/FormControlTypeCheckbox.vue'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
})

const showEditable = computed(() => {
    const type = props.currentData?.type
    const browser = props.currentData?.browser
    return ['text', 'currency'].includes(type) && !!browser
})

const isEditable = computed(() => props.currentData?.browser === 2)

const toggleEditable = () => {
    if (props.currentData) {
        props.currentData.browser = props.currentData.browser === 1 ? 2 : 1
    }
}
</script>

<template>
    <div class="form-control-structure-browser-wrapper">
        <div v-if="showEditable" class="d-flex align-items-center">
            <FormControlTypeCheckbox :current-data="currentData" :field="field" :form-id="formId"/>

            <span class="ms-3">
                <label class="d-inline-flex align-items-center gap-1">
                    <small>Make editable:</small>
                    <input
                        type="checkbox"
                        :checked="isEditable"
                        @change="toggleEditable"
                    >
                </label>
            </span>
        </div>

        <FormControlTypeCheckbox
            v-else
            :current-data="currentData"
            :field="field"
            :form-id="formId"
        />
    </div>
</template>

<style scoped>
/* Layout spacing overrides sit cleanly within parent structural rulesets */
</style>